import React, { useMemo } from 'react';
import JoditEditor from 'jodit-react';

export function TextEditor({ placeholder = '', name, value, onChange }) {
  const config = useMemo(() => {
    return {
      readonly: false,
      minHeight: 320,
      showCharsCounter: false,
      showWordsCounter: false,
      showXPathInStatusbar: false,
      placeholder: placeholder,
      fillEmptyParagraph: false,
    };
  }, [placeholder]);
  return (
    <div>
      <JoditEditor
        config={config}
        name={name}
        value={value}
        onChange={onChange}
        tabIndex={1} // tabIndex of textarea
      />
    </div>
  );
}
